import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';

export default function CustomerSyncStatusPanel({
    uniqueCustomers,
    customersSyncStatus,
    checkingCustomerLink,
    selectedConnection,
    handleSyncCustomer,
    syncing
}) {
    if (uniqueCustomers.length === 0) return null;

    return (
        <div className="border rounded p-2 bg-light d-flex flex-column gap-2 project-select-card scroll-container" style={{ maxHeight: '120px', overflowY: 'auto' }}>
            <span className="font-weight-bold text-muted small text-uppercase project-select-title">Customer Sync Status</span>
            {uniqueCustomers.map(cust => {
                const status = customersSyncStatus[cust.id];
                const isLinked = status?.isLinked;
                const isSyncing = status?.syncing;
                return (
                    <div key={cust.id} className="d-flex justify-content-between align-items-center w-100 py-1 border-bottom border-light last-child-border-0">
                        <div className="fw-bold text-truncate customer-select-name" style={{ maxWidth: '60%', fontSize: '0.875rem' }} title={cust.name}>
                            {cust.name}
                        </div>
                        <div className="ms-2">
                            {checkingCustomerLink ? (
                                <Spinner size="sm" animation="border" className="text-secondary" />
                            ) : isLinked ? (
                                <span className="badge bg-success customer-sync-badge">
                                    ✓ Linked ({selectedConnection?.platform === 'xero' ? 'Xero' : 'QBO'})
                                </span>
                            ) : (
                                <div className="d-flex align-items-center gap-2">
                                    <span className="badge bg-warning text-dark customer-sync-badge">Not Linked</span>
                                    <Button
                                        size="sm"
                                        variant="primary"
                                        onClick={() => handleSyncCustomer(cust.id)}
                                        disabled={isSyncing || syncing}
                                        className="customer-sync-btn py-0 px-2"
                                        style={{ fontSize: '0.75rem', height: '22px', display: 'flex', alignItems: 'center' }}
                                        data-cy={`sync-invoices-sync-customer-btn-${cust.id}`}
                                    >
                                        {isSyncing ? 'Syncing...' : 'Sync'}
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
